import DOMPurify from 'dompurify'

const Sanitize = {
	install (Vue) {
		Vue.prototype.$sanitize = (html, options = {}) => {
			return DOMPurify.sanitize(html, options)
		}
	}
}

export default Sanitize



// WEBPACK FOOTER //
// ./src/plugins/sanitize.js